var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/twitter.20eb2359.png","uri@2x": __webpack_public_path__ + "static/media/twitter.3fa42e92.png","uri@3x": __webpack_public_path__ + "static/media/twitter.847241d4.png",
    width: 24,
    height: 20
});